import { createContext, useContext, useMemo, useCallback, useRef } from 'react';
import AuthService from '../services/AuthService'
import { _csrfToken_ } from '../Constants';

export default function AuthProvider({ children }) {
	const data = useRef();

	const login = useCallback(async (credentials) => {
		const response = await AuthService.login(credentials);
		if (!response) {
			return null;
		}
		// save the user info object
		data.current = response;
		return response;
	}, []);


	const value = useMemo(() => {
		return {
			data,
			login,
			logout: () => data.current = null,
			isCsrfValid: async () => await AuthService.isCsrfValid(data[_csrfToken_]),
			isAuthenticated: () => !!data.current,
		}
	}, [data, login]);


	return (
		<AuthContext.Provider value={value}> {children}</AuthContext.Provider>
	)
}

export const AuthContext = createContext({})

export const useAuth = () => {
	return useContext(AuthContext)
}
